import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
} from "@mui/material";
import { maxLengthMessage } from "../../utils/functions";
import DropdownController from "../inputs/DropdownController";
import TextFieldController from "../inputs/TextFieldController";
import PATSaveButton from "../Buttons/PATSaveButton";
import PATCloseButton from "../Buttons/PATCloseButton";

// Validation schema
const tagSchema = yup.object().shape({
  type: yup.string().required("Tag type is required"),
  value: yup
    .string()
    .trim()
    .required("Value is required")
    .max(100, maxLengthMessage(100)),
});

const TagDialog = ({ open, onClose, onSave, initialData, tagTypeOptions }) => {
  const {
    control,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(tagSchema),
    defaultValues: {
      type: initialData?.type || "",
      value: initialData?.value || "",
    },
  });

  useEffect(() => {
    reset({
      type: initialData?.type || "",
      value: initialData?.value || "",
    });
  }, [initialData, reset]);

  useEffect(() => {
    if (!open) {
      reset();
    }
  }, [open, reset]);

  const onSubmit = (data) => {
    onSave(data);
    reset();
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>{initialData ? "Edit Tag" : "Add Tag"}</DialogTitle>
      <DialogContent>
        <Box
          component="form"
          onSubmit={handleSubmit(onSubmit)}
          noValidate
          sx={{ mt: 1 }}
        >
          <Box sx={{ mb: 2 }}>
            <DropdownController
              name="type"
              label="Tag Type"
              options={tagTypeOptions}
              control={control}
              errors={errors}
              required
            />
          </Box>

          <Box sx={{ mb: 2 }}>
            <TextFieldController
              name="value"
              label="Value"
              type="text"
              control={control}
              errors={errors}
              required
            />
          </Box>
        </Box>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2 }}>
        <PATSaveButton onClick={handleSubmit(onSubmit)} tooltipText="Save" />
        <PATCloseButton onClick={onClose} tooltipText="Close" />
      </DialogActions>
    </Dialog>
  );
};

export default TagDialog;
